import { Helpers } from '@smiles/core-utils';

import moment from 'moment';

export function handleGetHolidays() {
  const holidaysResponse = Helpers.getHolidays({
    range: { searchFlight: true },
  });

  const adapterHolidayServiceToCalendar = holidaysResponse.map((holiday) => ({
    date: moment(holiday.date),
    description: holiday.name,
    type: holiday.type,
  }));

  return adapterHolidayServiceToCalendar;
}
